import './App.css';
import Banner from './components/Banner';
import Header from './components/Headers';
import Footer from './components/Footer';
import { Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import Intro from './components/Intro';
import Service from './components/Service';
import Register from './components/Register';
import Policy from './components/Policy';

function App() {
  return (
    <div className='min-h-screen flex flex-col'>
      <Header/>
      <Banner/>
      <main className='flex-1'>
        <Routes>
          <Route exact path="/" element={<HomePage/>} />
          <Route exact path="gioithieu" element={<Intro/>} />
          <Route exact path="service" element={<Service/>} />
          <Route exact path="register" element={<Register/>} />
          <Route exact path="chinhSach" element={<Policy/>} />
        </Routes>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
